module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title68"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title68"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783469529_fm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TRUE CRIME FROM WHARNCLIFFE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783469529_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783469529_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783469529_fm02"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783469529_ack01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783469529_fm03"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sources")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c01"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Henry Asher")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c02"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("William Madden")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c03"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Richard Gould")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thomas Cooper")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Other Crimes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Jeremiah Tooley")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Celestina Somner")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Robert Robinson Tripp")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thomas Robert Davis")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Sarah Sadler")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 11")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("William Henry Clarke")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 12")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Charles Frederick Bricknell")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 13")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Mary Eliza Rorke")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 14")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("George Campbell")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 15")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Susan King")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 16")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Lydia Venables")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 17")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("George Hannay Wilson")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 18")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("William Cole")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 19")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Charles Cornish")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 20")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("John Lynch")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 21")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Thomas Neal")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 22")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Walter Alfred Hargan")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 23")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Alfred Gamble")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 24")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Alfred Chipperfield")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 25")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("John Grande, Charles Barrett and Alfred Jones")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 26")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Other Crimes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 27")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("George Chapman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 28")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Albert Bridgeman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 29")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Charles Henry Rogers and Jessie Elizabeth Lucas")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 30")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Walter Edward Fensham")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 31")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Arthur Robert Canham")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 32")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("James Lucas")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 33")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Frederick Williams")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 34")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Frederick George Murphy")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 35")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Harry Morley")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 36")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Michael Demetrios Xinaris")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 37")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Ronald Henry Marwood")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 38")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("John Patrick Quinlan")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 39")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Panayotis Gregoriou")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 40")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Kenneth Halliwell,")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783469529_c41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter 41")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Other Crimes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781783469529_ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7346d8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783469529_toc01.vue
// module id = 66
// module chunks = 0